module.exports = __webpack_public_path__ + "14095e48a2419c789e9c5585cdc863b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/over.png
// module id = 277
// module chunks = 0